import { IconKey, MenuItem } from "@homebound/beam";
import { CostType } from "src/generated/graphqlTypes";
import { LineType } from "src/routes/libraries/plan-package/takeoffs/components/AddItems/utils";

export const lineTypeDetails: Record<LineType, { label: string; icon: IconKey }> = {
  labor: { label: "Labor", icon: "wrench" },
  material: { label: "Material", icon: "cube" },
  placeholder: { label: "Placeholder", icon: "cubeDashed" },
};

export function lineTypeOf(tli: { costType: CostType; isPlaceholderMaterial: boolean }): LineType {
  if (tli.costType === CostType.Labor) return "labor";
  return tli.isPlaceholderMaterial ? "placeholder" : "material";
}

/** The Add menu's line types, for the header and the group rows' "+". */
export function addLineMenuItems(openAdd: (type: LineType) => void): MenuItem[] {
  return (["labor", "material", "placeholder"] satisfies LineType[]).map((type) => ({
    label: `Add ${lineTypeDetails[type].label}`,
    icon: lineTypeDetails[type].icon,
    onClick: () => openAdd(type),
  }));
}
